import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
  selector: "myqq-fourohfour",
  templateUrl: "./fourohfour.component.html",
  styleUrls: ["./fourohfour.component.scss"],
  standalone: false,
})
export class FourohfourComponent {
  supportEmail = environment.supportEmail;
  cdnHost = environment.cdnHost;

  constructor(private router: Router) {}

  refresh() {
    this.router.navigate(["/"]);
  }
}
